import React from 'react';
import classes from "./RatingBar.module.css"
import pb00 from "../../../assets/Game/bars/wb00.png"
import pb05 from "../../../assets/Game/bars/wb05.png"
import pb10 from "../../../assets/Game/bars/wb10.png"
import pb15 from "../../../assets/Game/bars/wb15.png"
import pb20 from "../../../assets/Game/bars/wb20.png"
import pb25 from "../../../assets/Game/bars/wb25.png"
import pb30 from "../../../assets/Game/bars/wb30.png"
import pb35 from "../../../assets/Game/bars/wb35.png"
import pb40 from "../../../assets/Game/bars/wb40.png"
import pb45 from "../../../assets/Game/bars/wb45.png"
import pb50 from "../../../assets/Game/bars/wb50.png"
import pb55 from "../../../assets/Game/bars/wb55.png"
import pb60 from "../../../assets/Game/bars/wb60.png"
import pb65 from "../../../assets/Game/bars/wb65.png"
import pb70 from "../../../assets/Game/bars/wb70.png"
import pb75 from "../../../assets/Game/bars/wb75.png"
import pb80 from "../../../assets/Game/bars/wb80.png"


type RatingTypes = {
    name: String,
    rating?: Number
}

const RatingBar:React.FC<RatingTypes> = ({name, rating}) => {

  let img = ""
  switch (rating) {
    case 3:
      img = pb00
      break;
    case 3:
      img = pb05
      break;
    case 4:
      img = pb10
      break;
    case 5:
      img = pb15
      break;
    case 6:
      img = pb20
      break;
    case 7:
      img = pb25
      break;
    case 8:
      img = pb30
      break;
    case 9:
      img = pb35
      break;
    case 10:
      img = pb40
      break;
    case 11:
      img = pb45
      break;
    case 12:
      img = pb50
      break;
    case 13:
      img = pb55
      break;
    case 14:
      img = pb60
      break;
    case 15:
      img = pb65
      break;
    case 16:
      img = pb70
      break;
    case 17:
      img = pb75
      break;
    case 18:
      img = pb80
      break;
  
    default:
      img = pb00
      break;
  }

  return (
    <div className={classes["strength-root"]}>
        <div className={classes["strength-title"]}>{name}</div>
        <img className={classes["strength-img"]} src={img} alt="" />
    </div>
  )
}

export default RatingBar